import { isObject as e } from "./index38.js";
function n(t, r) {
  return e(r) && t in r;
}
export {
  n as hasProperty
};
